import { render, staticRenderFns } from "./Summation.vue?vue&type=template&id=12e073e7&scoped=true"
import script from "./Summation.vue?vue&type=script&lang=js"
export * from "./Summation.vue?vue&type=script&lang=js"
import style0 from "./Summation.vue?vue&type=style&index=0&id=12e073e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e073e7",
  null
  
)

export default component.exports